export default __webpack_public_path__ + "static/media/dataset-body.53c0a520.svg";